<div class="superbill-setup">
  <h3>SUPERBILL</h3>
  <p class="hint">
    Map each purchased item to the insurance code that should print on the customer superbill.
    The superbill uses the amount actually charged on the order. It is emailed after the balance is $0.00.
  </p>

  <h4>PROVIDER INFORMATION</h4>
  <p class="hint">Printed on every superbill. Leave a field blank to omit it.</p>
  <div class="draft-row">
    <mat-form-field>
      <mat-label>PROVIDER NAME</mat-label>
      <input matInput [(ngModel)]="profile.providerName" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>NPI</mat-label>
      <input matInput [(ngModel)]="profile.npi" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>LICENSE</mat-label>
      <input matInput [(ngModel)]="profile.licenseNumber" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>TAX ID</mat-label>
      <input matInput [(ngModel)]="profile.taxId" autocomplete="off">
    </mat-form-field>
  </div>
  <mat-form-field class="wide">
    <mat-label>STATEMENT</mat-label>
    <textarea matInput rows="3" [(ngModel)]="profile.statement"></textarea>
  </mat-form-field>
  <mat-form-field class="wide">
    <mat-label>SIGNATURE LINE</mat-label>
    <input matInput [(ngModel)]="profile.signatureNote" autocomplete="off">
  </mat-form-field>
  <div>
    <button mat-raised-button type="button" [disabled]="saving" (click)="saveProfile()">SAVE PROVIDER INFORMATION</button>
  </div>

  <h4>ITEM CODES</h4>
  <div class="draft-row">
    <mat-form-field>
      <mat-label>ITEM / DISPLAY NAME</mat-label>
      <input matInput [(ngModel)]="draft.displayName" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>INSURANCE CODE</mat-label>
      <input matInput [(ngModel)]="draft.insuranceCode" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>APPLIES TO</mat-label>
      <mat-select [(ngModel)]="draft.matchKey">
        <mat-option *ngFor="let match of matchKeys" [value]="match.key">{{ match.label | uppercase }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button type="button" [disabled]="saving" (click)="add()">ADD</button>
  </div>

  <table class="code-table" *ngIf="codes.length">
    <tr>
      <th>ITEM / DISPLAY NAME</th>
      <th>INSURANCE CODE</th>
      <th>APPLIES TO</th>
      <th>ACTIVE</th>
      <th></th>
    </tr>
    <tr *ngFor="let code of codes">
      <td>
        <mat-form-field>
          <input matInput [(ngModel)]="code.displayName">
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <input matInput [(ngModel)]="code.insuranceCode">
        </mat-form-field>
      </td>
      <td>
        <mat-select [(ngModel)]="code.matchKey">
          <mat-option *ngFor="let match of matchKeys" [value]="match.key">{{ match.label | uppercase }}</mat-option>
        </mat-select>
      </td>
      <td>
        <mat-checkbox [(ngModel)]="code.active"></mat-checkbox>
      </td>
      <td class="actions">
        <button mat-button type="button" [disabled]="saving" (click)="saveCode(code)">SAVE</button>
        <button mat-button type="button" (click)="remove(code)">REMOVE</button>
      </td>
    </tr>
  </table>
</div>
